export type NomeRankFa  = 'Estreante' | 'Fã Dedicado' | 'Lenda';
export type IconeRankFa = 'Star' | 'Heart' | 'Crown';

/**
 * Limiares de total_pedidos — espelham as conquistas computadas em
 * jukebox_perfil_completo (database/migration_jukebox_perfil.sql). Mudar
 * aqui sem mudar lá desalinha o Rank de Fã das conquistas
 * "Estreante"/"Fã Dedicado"/"Lenda".
 */
export const LIMIAR_ESTREANTE   = 1;
export const LIMIAR_FA_DEDICADO = 20;
export const LIMIAR_LENDA       = 100;

export interface RankFa {
  nivel:         0 | 1 | 2 | 3;
  nome:          NomeRankFa | null;
  icone:         IconeRankFa | null;
  /** 0–100, progresso até o próximo nível. 100 quando já é Lenda (nível máximo). */
  progressoPct:  number;
  /** null quando já é Lenda — não há próximo nível. */
  faltamPedidos: number | null;
}

/**
 * Deriva o Rank de Fã a partir de total_pedidos, reaproveitando os mesmos
 * limiares das conquistas "Estreante"/"Fã Dedicado"/"Lenda" já computadas
 * no backend — não introduz uma escala paralela.
 */
export function calcularRankFa(totalPedidos: number): RankFa {
  if (totalPedidos < LIMIAR_ESTREANTE) {
    return {
      nivel: 0,
      nome: null,
      icone: null,
      progressoPct: Math.round((totalPedidos / LIMIAR_ESTREANTE) * 100),
      faltamPedidos: LIMIAR_ESTREANTE - totalPedidos,
    };
  }

  if (totalPedidos < LIMIAR_FA_DEDICADO) {
    const progresso = (totalPedidos - LIMIAR_ESTREANTE) / (LIMIAR_FA_DEDICADO - LIMIAR_ESTREANTE);
    return {
      nivel: 1,
      nome: 'Estreante',
      icone: 'Star',
      progressoPct: Math.round(progresso * 100),
      faltamPedidos: LIMIAR_FA_DEDICADO - totalPedidos,
    };
  }

  if (totalPedidos < LIMIAR_LENDA) {
    const progresso = (totalPedidos - LIMIAR_FA_DEDICADO) / (LIMIAR_LENDA - LIMIAR_FA_DEDICADO);
    return {
      nivel: 2,
      nome: 'Fã Dedicado',
      icone: 'Heart',
      progressoPct: Math.round(progresso * 100),
      faltamPedidos: LIMIAR_LENDA - totalPedidos,
    };
  }

  return {
    nivel: 3,
    nome: 'Lenda',
    icone: 'Crown',
    progressoPct: 100,
    faltamPedidos: null,
  };
}
